module.exports = require('./LitigationHoldLabelView');
